module.exports = require('./LitigationHoldLabelView');
